import { useEffect, useRef, useState } from "react";
import { TOOLBAR_HIGHLIGHT_DURATION_MS } from "../tokens.ts";

/**
 * Returns `true` for `TOOLBAR_HIGHLIGHT_DURATION_MS` after the input transitions
 * from `false` → `true`. Used to briefly pulse a `Tool` when it becomes newly
 * available (e.g. a mode button that just became relevant to the selection).
 */
export function useHighlightOnChange(trigger: boolean): boolean {
  const prevRef = useRef(trigger);
  const mountRef = useRef(true);
  const [lit, setLit] = useState(false);

  useEffect(() => {
    if (mountRef.current) {
      mountRef.current = false;
      prevRef.current = trigger;
      return;
    }

    if (trigger && !prevRef.current) {
      setLit(true);
      const id = setTimeout(() => setLit(false), TOOLBAR_HIGHLIGHT_DURATION_MS);
      prevRef.current = trigger;
      return () => clearTimeout(id);
    }

    prevRef.current = trigger;
  }, [trigger]);

  return lit;
}
